import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

// interfaces
import { IRegion } from 'src/app/core/interfaces/location/region';
import { IUserInfo  } from 'src/app/core/interfaces/user/user-info';

// services
import { AuthService } from 'src/app/core/services/user/auth.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

export const regionsResolver: ResolveFn<Observable<IRegion[]>> = (route, state) => {

  // init
  const _auth = inject(AuthService);
  const _api = inject(ApiResponseService); 

  // ES6 Destruction
  const { country: { id } } = _auth.userInfo.value as IUserInfo ;

  /**
   * 
   */
  return _api.getRegions(id ? id : 1);  

};
